import TrainingSession from '../session';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingSession.update((data, fetch) => {
    // Prepare request
    let formData = new FormData();
    formData.append('_method', 'PUT');
    ['title', 'description', 'order_index', 'image', 'delete_image']
        .map(key => data[key] !== undefined ? formData.append(key, data[key]) : null);
    
    return fetch.post(`/trainings/${data.trainingId}/sessions/${data.sessionId}`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
